<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Item
            </h4>
            <p class="category font-weight-thin">
              Edit Fund Bucket Item
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-container>
        <v-row>
          <v-col class="title">
            {{ existingBucketItem.company.name }}
          </v-col>
        </v-row>

        <v-form
          v-if="dialog && !loading"
          ref="form"
          lazy-validation
        >
          <v-row>
            <v-col>
              <v-combobox
                v-model="existingBucketItem.bucket"
                item-text="name"
                item-value="id"
                :items="filteredBucketHasTypes"
                :rules="bucketRules"
                label="Bucket"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-combobox
                v-model="existingBucketItem.description"
                item-text="description"
                item-value="id"
                :items="bucketDescriptions"
                :rules="descriptionRules"
                label="Description"
                required
              />
            </v-col>
          </v-row>
                            
          <v-row>
            <v-col>
              <v-text-field
                v-model="existingBucketItem.min"
                label="Min. Amount"
                :rules="[minLogic]"
                required
                @input="$set(existingBucketItem,existingBucketItem.min,parseFloat($event))"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="existingBucketItem.interval"
                label="Interval"
                :rules="[intervalLogic]"
                required
                @input="$set(existingBucketItem,existingBucketItem.min,parseFloat($event))"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="existingBucketItem.max"
                label="Max. Amount"
                :rules="[maxLogic]"
                required
                @input="$set(existingBucketItem,existingBucketItem.min,parseFloat($event))"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-select
                v-model="existingBucketItem.priority"
                item-text="name"
                :items="priorities"
                label="Priority"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <p class="mt-5">
                Valid?    
              </p>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-model="existingBucketItem.is_valid"
                color="success"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <p class="mt-5">
                Has Quota?    
              </p>
            </v-col>
            <v-col cols="1">
              <v-switch
                v-model="existingBucketItem.quota"
                color="success"
              />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success"
              @click="submitForm"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      category: String,
      item: Object,
    },
    data: () => ({
      dialog: false,
      loading: false,
      schemaRules: [
        v => !!v || '*This field is required',
      ],
      companyRules: [
        v => !!v || '*This field is required',
      ],
      bucketRules: [
        v => !!v || '*This field is required',
      ],
      descriptionRules: [
        v => !!v || '*This field is required',
      ],
      minRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
        v => ((!!v && !isNaN(v)) && /^\d+(\.\d{1,2})?$/.test(v)) || '*Only 2 Decimal is allowed',
      ],
      maxRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
        v => ((!!v && !isNaN(v)) && /^\d+(\.\d{1,2})?$/.test(v)) || '*Only 2 Decimal is allowed',
      ],
      intervalRules: [
        v => !!v || '*This field is required',
        v => (!!v && !isNaN(v)) || 'Only number is allowed',
      ],
      companies: [],
      buckets: [],
      bucketDescriptions: [],
      priorities: [],
      schemas: [],
      fundBucketHasTypes: [],
      existingBucketItem: {
        id: '',
        schema: '',
        company: '',
        bucket: '',
        description: '',                
        min: 0,
        max: 0,
        interval: 0,
        priority: '',
        is_valid: '',
        quota: false,
      },
    }),
    computed: {
      filteredBucketHasTypes () {
        if (!this.existingBucketItem.schema) return
        
        return this.fundBucketHasTypes.filter(fundBucketHasType => {
          return fundBucketHasType.schemaName === this.existingBucketItem.schema
        })
      },
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
          this.$refs.form.resetValidation()
        } else {
          this.loadData() 
        }
      },
      existingBucketItem: 'validate',
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().list(), // list all companies
          this.$api.fundBucketItemDescriptions().list(), // list all description
          this.$api.fundBucketItems().list(), // list all priorities
          this.$api.companies().withSchema(), // list all schemas
          this.$api.fundBucketHasTypes().list(), // use for list all bucket, then filter at computed
        ]) 
          .then(([companies, bucketDescriptions, fundBucketItems, schemas, fundBucketHasTypes]) => {
            this.companies = companies.data
            this.bucketDescriptions = bucketDescriptions.data
            const temp = this.companies
              .filter(company => company.id === this.item.company_id)
              .map(company => company.schema_name)
            this.existingBucketItem.schema = temp[0]
            fundBucketItems.data.map(item => {
              this.priorities.push(item.priority)
              this.priorities.sort(function (a, b) { return a - b })
            })
            schemas.data.map(item => {
              this.schemas.push(item.schema_name)
            })
            fundBucketHasTypes.data.map(item => {
              this.fundBucketHasTypes.push({ 
                id: item.fund_bucket.id,
                name: item.fund_bucket.name,
                schemaName: item.schema_name, 
              })
            })
            this.existingBucketItem.id = this.item.id
            this.existingBucketItem.company = this.item.company
            this.existingBucketItem.bucket = this.item.fund_bucket
            this.existingBucketItem.description = this.item.fund_bucket_item_descriptions
            this.existingBucketItem.min = this.item.min
            this.existingBucketItem.max = this.item.max
            this.existingBucketItem.interval = this.item.multiple_of
            this.existingBucketItem.priority = this.item.priority
            this.existingBucketItem.is_valid = this.item.is_valid
            this.existingBucketItem.quota = this.item.has_quota
            this.loading = false
          })
      },
      validate: function () {
        this.$refs.form.validate()
      },
      submitForm () {
        if (this.$refs.form.validate()) {
          this.$api.fundBucketItems().update(this.existingBucketItem.id, this.prepareForm())
            .then((response) => {
              if (response.status === 200) {
                this.$emit('updated')
                this.$snack({ color: 'success', message: response.data.message })

                this.dialog = false 
              }
            })              
        }
      },
      prepareForm () {
        return {
          bucket_id: this.existingBucketItem.bucket.id,
          description_id: this.existingBucketItem.description.id,
          min: this.existingBucketItem.min,
          max: this.existingBucketItem.max,
          multiple_of: this.existingBucketItem.interval,
          has_quota: this.existingBucketItem.quota,
          priority: this.existingBucketItem.priority,
          is_valid: this.existingBucketItem.is_valid,
        }
      },
      maxLogic () {
        if (this.existingBucketItem.max !== '') {
          if (!isNaN(this.existingBucketItem.max)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.existingBucketItem.max)) {
              if (parseFloat(this.existingBucketItem.max) <= parseFloat(this.existingBucketItem.min)) {
                return 'Max cannot less than or equal to Min'
              }
              if (this.existingBucketItem.min !== '' && this.existingBucketItem.interval !== '') {
                const min = parseFloat(this.existingBucketItem.min)
                const interval = parseFloat(this.existingBucketItem.interval)
                const max = parseFloat(this.existingBucketItem.max)
                let n = 0
                if (parseFloat(this.existingBucketItem.interval) > parseFloat(this.existingBucketItem.max)) {
                  n = Math.ceil((max - min) / interval)
                } else {
                  n = Math.floor((max - min) / interval)
                }
                let actualMax = ((n * interval) + min)
                while (!(/^\d+(\.\d{1,2})?$/.test(actualMax)) && n > 0) {
                  const a = ((n * interval) + min)
                  actualMax = a
                  n--
                }
                if (((((parseFloat(this.existingBucketItem.max) - parseFloat(this.existingBucketItem.min)) * 100) % (parseFloat(this.existingBucketItem.interval) * 100))) / 100 !== 0) {
                  return 'Do you mean ' + actualMax + '?'
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }
        return true
      },
      minLogic () {
        if (this.existingBucketItem.min !== '' || this.existingBucketItem.min === '0') {
          if (!isNaN(this.existingBucketItem.min)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.existingBucketItem.min)) {
              if (parseFloat(this.existingBucketItem.min) >= parseFloat(this.existingBucketItem.max)) {
                return 'Min cannot greater than or equal to Max'
              }
              if (this.existingBucketItem.interval !== '' && this.existingBucketItem.max !== '') {
                const min = parseFloat(this.existingBucketItem.min)
                const interval = parseFloat(this.existingBucketItem.interval)
                const max = parseFloat(this.existingBucketItem.max)
                let n = Math.floor((max - min) / interval)
                let actualMin = (max - (n * interval))
                while (!(/^\d+(\.\d{1,2})?$/.test(actualMin)) && n > 0) {
                  const a = (max - (n * interval))
                  actualMin = a
                  n--
                }
                if (((((parseFloat(this.existingBucketItem.max) - parseFloat(this.existingBucketItem.min)) * 100) % (parseFloat(this.existingBucketItem.interval) * 100)) / 100) !== 0) {
                  return 'Do you mean ' + actualMin + '?' 
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }
        return true
      },
      intervalLogic () {
        if (this.existingBucketItem.interval !== '') {
          if (!isNaN(this.existingBucketItem.interval)) {
            if (/^\d+(\.\d{1,2})?$/.test(this.existingBucketItem.interval)) {
              if (parseFloat(this.existingBucketItem.interval) > parseFloat(this.existingBucketItem.max)) {
                return 'Interval cannot greater than Max'
              }
              if (this.existingBucketItem.min !== '' && this.existingBucketItem.max !== '') {
                const min = parseFloat(this.existingBucketItem.min)
                const interval = parseFloat(this.existingBucketItem.interval)
                const max = parseFloat(this.existingBucketItem.max)
                let n = Math.floor((max - min) / interval)
                let actualInterval = ((max - min) / n)
                while (!(/^\d+(\.\d{1,2})?$/.test(actualInterval)) && n > 0) {
                  const a = ((max - min) / n)
                  actualInterval = a
                  n--
                }
                if (((((parseFloat(this.existingBucketItem.max) - parseFloat(this.existingBucketItem.min)) * 100) % (parseFloat(this.existingBucketItem.interval) * 100)) / 100) !== 0) {
                  return 'Do you mean ' + actualInterval + '?'
                }
              }
            } else {
              return '*Only 2 Decimal is allowed'
            }
          } else {
            return 'Only number is allowed'
          }
        } else {
          return '*This field is required'
        }
        return true
      },
    },
  }
</script>
